var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Label, translate } from '@lucidlink/uicore';
import { Path } from '#components';
import { PII_BLOCK_CLASS } from '#constants';
import { GuestDetailsDrawerTestIdFactory } from './interactions';
export const GuestLinkPath = ({ pathQuery, status }) => {
    const { data, isError, isPending } = pathQuery;
    switch (true) {
        case status === 'invalidated':
        case data?.status === 'deleted':
            return (_jsx(Box, { children: _jsx(Label, { color: "static_alert", "data-testid": GuestDetailsDrawerTestIdFactory.getDeletedEntryTestId(), text: translate('File or folder deleted') }) }));
        case isError:
        case data?.status === 'failed':
            return (_jsx(Box, { children: _jsx(Label, { color: "static_error", "data-testid": GuestDetailsDrawerTestIdFactory.getFailedPathTestId(), text: translate('Failed to resolve link path') }) }));
        default:
            return (_jsx(Path, { className: PII_BLOCK_CLASS, isLoading: isPending, path: data?.status === 'resolved' ? data.path : undefined, rootType: data?.status === 'resolved' ? data.type : undefined }));
    }
};
_react_refresh_temp_1 = GuestLinkPath;
$RefreshReg$(_react_refresh_temp_1, "GuestLinkPath");
